<template>
	<div>
		<div class="mb-3">
			<base-radio v-for="(el_opt, el_index) in options" :key="el_opt.name+'_'+el_index" :name="el_opt.name" v-model="choise" inline @input="rbCange">{{el_opt.label}}</base-radio>
		</div>
		<div>
			<ReInputSearchDrop v-show="choise=='other_agent'"
				name="fio"
				:placeholder="placeholder"
				v-model="objStaff_in"
				:objApiMethod="{obj:'staff' ,flt:{fio:''}}"
				strApiMethodKey="fio"
				v-on:change="OnAjaxListSearch"
			/>
			
			<el-select v-if="choise=='Helpdesk'"
					class="w-100 select-primary overflow-overlay"
					size="large"
					placeholder="Выбор хелпдеска"
					v-model="hdselect"
					@change="OnHDSelect"
				>
					<el-option
						v-for="(el_opt, el_index) in masHDSelect"
						class="select-primary"
						:value="el_opt.value"
						:label="el_opt.label"
						:key="el_index"
					>
					</el-option>
			</el-select>
		</div>
	</div>
</template>

<script>
	import ReInputSearchDrop from 'src/our_components/ReInputSearchDrop.vue';
	import { /*BaseCheckbox,*/ BaseRadio, /*BaseSwitch,*/ } from 'src/components/index';
	import { Select, Option } from 'element-ui';
	export default {
		name: 'ReCurator',
		components: {
			ReInputSearchDrop,
			// BaseCheckbox,
			BaseRadio,
			// BaseSwitch,
			[Option.name]: Option,
			[Select.name]: Select,
		},
		props: {
			value: String,
			placeholder: String,
			options: { 
				type: Array,
				default(){
					return [
						{name:'agent', label: 'Агент ответственный за услугу'},
						{name:'agent_head', label: 'Начальник агента ответсвенного за услугу'},
						{name:'other_agent', label: 'Сотрудник из текстового поля'},
						{name:'Helpdesk',label:'Группа сотрудников из селекта'},
					]
				}
			},
			objStaff: Object,
			findId: { 
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				choise: '',
				objStaff_in: {inputText:'',selectedVal:''},
				masHDSelect:[],
				hdselect:'',
			}
		},
		computed: {

		},
		methods: {
			OnAjaxListSearch(opt){
				//console.log(opt.selectedVal);
				this.$emit('input', opt.selectedVal);
			},
			OnHDSelect(opt){
				//console.log(opt);
				this.$emit('input', opt);
			},
			rbCange(opt){
				//console.log(opt);
				if(opt != 'other_agent'){
					if(opt != 'Helpdesk'){
						this.$emit('input', opt);
						this.$emit('change', opt);
					}else{
						//this.$emit('input', hdselect);
						//this.$emit('change', hdselect);
					}
				}else{
					if (this.objStaff_in.selectedVal == '') {
						this.$emit('input', '');
						this.$emit('change', '');	
					}else{
						this.$emit('input', this.objStaff_in.selectedVal);
						this.$emit('change', this.objStaff_in.selectedVal);
					}
				}
			},
			inOptions(){
				for (let i = 0; i < this.options.length; i++) {
					if(this.options[i].name == this.value) return true;
				}
				return false;
			},
			getHDSelect(){
				this.masHDSelect = [];
				this.$GVO.ApiCall('HELPDESK.GET',{flt:{'list':'true'}})
				.then((objApi) => {
					if(objApi.success === true){
						if(objApi.data.length > 0){
							for (let i = 0; i < objApi.data.length; i++) {
								this.masHDSelect.push({'value':'hdid_'+objApi.data[i].id,'label':objApi.data[i].name});
							}
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
			}
		},
		mounted(){
			this.getHDSelect();
			if(this.value != ''){
				if(this.inOptions()){
					this.choise = this.value;
				}else{
					if(this.value.indexOf('hdid_')!=-1){
						this.choise = 'Helpdesk';
						this.hdselect = this.$GVO.unlinkObject(this.value);
					}else{
						this.choise = 'other_agent';
					}
				}
				this.objStaff_in = this.objStaff;
			}
		}
	}
</script>
<style scoped>

</style>
